<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M2.08594 5H7.91927" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5 2.08337L7.91667 5.00004L5 7.91671" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'RightIcon'
}
</script>
